<div class="padding-30 d-flex">
	<dz-progress-spinner></dz-progress-spinner>
</div>
